import { useState } from 'react';
import { Menu, MenuItem, Button } from '@mui/material';

export const CategoriesMenu = ({
  selectedCategory,
  categories,
  selectCategory,
  rtl,
}: {
  selectedCategory: any;
  categories: any[];
  selectCategory: (category: any) => void;
  rtl: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="category-button"
        aria-controls={open ? 'category-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<i className="fa-solid fa-chevron-down" style={{ fontSize: '18px', fontWeight: 500 }} />}
        sx={{
          display: { xs: 'none', lg: 'inline-flex' },
          height: '47px',
          borderRadius: '8px',
          border: '1px solid #D0D5DD',
          whiteSpace: 'break-spaces',
          background: '#FFF',
          fontSize: '16px',
          fontWeight: 500,
          m: 0,
          color: '#000',
          '&:hover': {
            background: '#FFF',
            color: '#000',
          },
          '&:focus': {
            border: '1px solid #D0D5DD',
          },
          '.MuiButton-endIcon': {
            marginLeft: rtl ? '0' : '16px',
            marginRight: rtl ? '16px' : '0',
            width: '38px',
            borderLeft: '1px solid #D0D5DD',
            height: 'inherit',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
      >
        {selectedCategory?.title || rtl ? 'הכל' : 'All'}
      </Button>
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id="category-menu"
        MenuListProps={{
          'aria-labelledby': 'category-button',
          sx: { background: '#fff' },
        }}
        sx={{
          direction: rtl ? 'rtl' : 'ltr',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {[{ id: 'empty', title: rtl ? 'הכל' : 'All' }, ...categories].map((category) => {
          return (
            <MenuItem
              key={category.id}
              onClick={() => {
                if (category.id === 'empty') {
                  selectCategory(null);
                } else {
                  selectCategory(category);
                }
                handleClose();
              }}
              disableRipple
              sx={{
                background: selectedCategory?.id === category.id ? 'rgba(130, 130, 130, 0.08);' : '#FFF',
              }}
            >
              {category.title}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
